import { Injectable, NgModule } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NgRedux<T extends object = any> {
  private reducer: ((state: T | undefined, action: any) => T) | null = null;
  private state$ = new BehaviorSubject<T>({} as T);

  configureStore(reducer: (state: T | undefined, action: any) => T, initialState: T): void {
    this.reducer = reducer;
    this.state$.next(initialState);
  }

  dispatch(action: any): void {
    if (!this.reducer) {
      return;
    }

    this.state$.next(this.reducer(this.state$.value, action));
  }

  select<R = any>(key?: keyof T | string): Observable<R> {
    return this.state$.pipe(
      map((state: any) => (key ? state[key as string] : state) as R),
      // Without this, every dispatch (anywhere in the app) re-emits every
      // selected slice, even ones the action didn't touch — e.g. a new chat
      // message dispatching UpdateConversation would also re-fire the
      // 'activeConversation' selector, whose subscriber in ChatComponent
      // unconditionally resets its local message list from that (unrelated,
      // stale) slice and reconnects the websocket.
      distinctUntilChanged()
    );
  }
}

@NgModule({})
export class NgReduxModule {}
